export const REGEX = {
  STRING_ONLY: /^[a-zA-Z]+/,
  SANTIZE_CHARACTERS: /[&\s]+/g,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
